import axios from "axios";
import { safeSlugify } from "@/lib/helpers";

export default class SwaggerObject {
  constructor() {
    this.apiKey = null;
    this.datasetData = null;
    this.datasetName = null;
    this.datasetUrl = null;
    this.description = null;
    this.summary = null;
    this.url = null;
    this.docsUrl = null;
    this.tags = null;
    this.schema = null;
    this.rawData = null;
    this.datasets = null;
  }

  getSummary(datasetName) {
    return this.rawData.paths[datasetName].get.summary.replace("List - ", "");
  }

  getDescription(datasetName) {
    return this.rawData ? this.rawData.paths[datasetName].get.description : "";
  }

  getDatasetUrl(datasetName) {
    return `https://${this.rawData.host}${this.rawData.basePath}${datasetName}`;
  }

  getApiKey() {
    const key = this.rawData.info.description.match(/publick API key `(.*?)`./);
    return key[1];
  }

  getTags(datasetName) {
    return this.rawData ? this.rawData.paths[datasetName].get.tags : "";
  }

  getDocsUrl(datasetName) {
    const itemPath = safeSlugify(this.getSummary(datasetName));
    const tag = safeSlugify(this.getTags(datasetName)[0]);

    return {
      name: "documentation",
      hash: "tag/" + tag + "/paths/~1" + itemPath + "/get"
    };
  }

  getSchema(datasetName) {
    const schema = this.rawData.paths[datasetName].get.responses[200].schema
      .properties.items.items.properties;

    return Object.keys(schema).map(key => ({
      ...schema[key],
      name: key
    }));
  }

  getDatasetsFromUrl() {
    return this.rawData.paths;
  }

  setGlobalData(data) {
    this.rawData = data;
    this.datasets = this.getDatasetsFromUrl();
  }

  setCurrentData(datasetName) {
    this.datasetName = datasetName;
    this.apiKey = this.getApiKey(datasetName);
    this.datasetUrl = this.getDatasetUrl(datasetName);
    this.description = this.getDescription(datasetName);
    this.summary = this.getSummary(datasetName);
    this.tags = this.getTags(datasetName);
    this.docsUrl = this.getDocsUrl(datasetName);
    this.schema = this.getSchema(datasetName);
  }

  setDatasetData(data) {
    this.datasetData = data.items;
  }

  async fetch() {
    await axios
      .get(this.datasetUrl, {
        headers: {
          "x-api-key": this.apiKey
        }
      })
      .then(response => {
        this.setDatasetData(response.data);
      });
  }

  async fetchDatasetData(datasetName) {
    this.setCurrentData(datasetName);
    this.fetch();
  }

  async init(url, datasetName) {
    await axios.get(url).then(response => {
      this.setGlobalData(response.data);
    });

    if (datasetName) {
      this.fetchDatasetData(datasetName);
    }
  }
}
